import * as access_agentic_platform from './access-agentic-platform';
import * as access_charity_crm from './access-charity-crm';
import * as access_collect from './access-collect';
import * as access_mail from './access-mail';
import * as access_sms from './access-sms';
import * as access_crm from './access-crm';
import * as access_document from './access-document';
import * as access_donorfy from './access-donorfy';
import * as access_evo from './access-evo';
import * as access_kanban from './access-kanban';
import * as access_financials from './access-financials';
import * as access_financials_mcp from './access-financials-mcp';
import * as access_paycircle from './access-paycircle';
import * as access_payroll from './access-payroll';
import * as access_peoplehr from './access-peoplehr';
import * as data_engine_api from './data-engine-api';
import * as evo_web_feed from './evo-web-feed';

export const access_integrationsNodes = {
  'access-agentic-platform': access_agentic_platform,
  'access-charity-crm': access_charity_crm,
  'access-collect': access_collect,
  'access-mail': access_mail,
  'access-sms': access_sms,
  'access-crm': access_crm,
  'access-document': access_document,
  'access-donorfy': access_donorfy,
  'access-evo': access_evo,
  'access-financials': access_financials,
  'access-financials-mcp': access_financials_mcp,
  'access-kanban': access_kanban,
  'access-paycircle': access_paycircle,
  'access-payroll': access_payroll,
  'access-peoplehr': access_peoplehr,
  'data-engine-api': data_engine_api,
  'evo-web-feed': evo_web_feed,
};
